import { Toaster } from 'react-hot-toast';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './contexts/AuthContext';
import BranchManagement from './pages/admin/BranchManagement';
import SystemSettings from './pages/admin/SystemSettings';
import TenantManagement from './pages/admin/TenantManagement';
import AppRedirect from './pages/App';

// Owner Pages
import Employees from './pages/owner/Employees';
import Locations from './pages/owner/Locations';
import Schedule from './pages/owner/Schedule';
import Requests from './pages/owner/Requests';
import Payroll from './pages/owner/Payroll';
import BusinessSettings from './pages/owner/BusinessSettings';

// Employee Pages
import EmployeeHome from './pages/employee/EmployeeHome';
import EmployeeSchedule from './pages/employee/EmployeeSchedule';
import LeaveRequest from './pages/employee/LeaveRequest';
import HoursEarnings from './pages/employee/HoursEarnings';
import Login from './pages/Login';

// Admin Pages

// Manager Pages
import ManagerSchedule from './pages/manager/ManagerSchedule';
import ManagerRequests from './pages/manager/ManagerRequests';
import ManagerAttendance from './pages/manager/ManagerAttendance';
import ManagerHome from './pages/manager/ManagerHome';
import OwnerHome from './pages/owner/OwnerHome';
import Settings from './pages/Settings';
import Signup from './pages/Signup';
import SignupBusiness from './pages/SignupBusiness';
import './index.css';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" />
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/signup/business" element={<SignupBusiness />} />
          
          {/* App Redirect */}
          <Route path="/app" element={<AppRedirect />} />
          
          {/* Owner Routes */}
          <Route path="/owner" element={<ProtectedRoute allowedRoles={['owner']} />}>
            <Route index element={<Navigate to="/owner/home" replace />} />
            <Route path="home" element={<OwnerHome />} />
            <Route path="employees" element={<Employees />} />
            <Route path="locations" element={<Locations />} />
            <Route path="schedule" element={<Schedule />} />
            <Route path="payroll" element={<Payroll />} />
            <Route path="business-settings" element={<BusinessSettings />} />
          </Route>
          
          {/* Employee Routes - EXACTLY 3 SCREENS */}
          <Route path="/employee" element={<ProtectedRoute allowedRoles={['employee']} />}>
            <Route index element={<Navigate to="/employee/home" replace />} />
            <Route path="home" element={<EmployeeHome />} />
            <Route path="schedule" element={<EmployeeSchedule />} />
            <Route path="earnings" element={<HoursEarnings />} />
          </Route>
          
          {/* Manager Routes - EMPLOYEE + 3 MANAGER TOOLS */}
          <Route path="/manager" element={<ProtectedRoute allowedRoles={['manager']} />}>
            <Route index element={<Navigate to="/manager/requests" replace />} />
            <Route path="requests" element={<ManagerRequests />} />
            <Route path="schedule" element={<ManagerSchedule />} />
            <Route path="attendance" element={<ManagerAttendance />} />
          </Route>
          
          {/* Admin Routes */}
          <Route path="/admin" element={<ProtectedRoute allowedRoles={['admin']} />}>
            <Route index element={<Navigate to="/admin/tenants" replace />} />
            <Route path="tenants" element={<TenantManagement />} />
            <Route path="branches" element={<BranchManagement />} />
            <Route path="settings" element={<SystemSettings />} />
          </Route>
          
          {/* Settings - Available to all authenticated users */}
          <Route path="/settings" element={<ProtectedRoute allowedRoles={['owner', 'employee', 'manager', 'admin']} />}>
            <Route index element={<Settings />} />
          </Route>
          
          {/* 404 */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
